// VFX: Bar Chart Race
// Category: data-viz  ·  Tags: bar, chart, race, data, animated
// Horizontal bars grow and reorder dynamically — great for comparisons.
import {
  AbsoluteFill,
  useCurrentFrame,
  useVideoConfig,
  interpolate,
  spring,
} from "remotion";
import React from "react";

const clamp = {
  extrapolateLeft: "clamp",
  extrapolateRight: "clamp",
} as const;

type Bar = { label: string; values: number[]; color: string };

const BARS: Bar[] = [
  { label: "Claude", values: [40, 65, 92], color: "#a855f7" },
  { label: "GPT", values: [70, 78, 80], color: "#06b6d4" },
  { label: "Gemini", values: [25, 45, 70], color: "#f97316" },
  { label: "Llama", values: [20, 32, 50], color: "#10b981" },
];

export default function DataBarChartRaceAnimatedLoop() {
  const frame = useCurrentFrame();
  const { durationInFrames, fps } = useVideoConfig();
  const p = frame / durationInFrames;
  const stage = Math.min(2, Math.floor(p * 3));
  const stageP = (p * 3) % 1;

  const items = BARS.map((b) => {
    const from = b.values[stage];
    const to = b.values[Math.min(2, stage + 1)];
    const value = from + (to - from) * stageP;
    return { ...b, value };
  });
  // sort desc by value
  const sorted = [...items].sort((a, b) => b.value - a.value);
  const maxVal = Math.max(...items.map((b) => b.value));

  return (
    <AbsoluteFill
      style={{
        background: "#0a0e1a",
        padding: "120px 80px",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <div
        style={{
          fontSize: 56,
          fontWeight: 800,
          color: "#f8fafc",
          marginBottom: 60,
        }}
      >
        Model adoption
      </div>
      <div
        style={{ display: "flex", flexDirection: "column", gap: 32 }}
      >
        {sorted.map((bar, i) => {
          const sp = spring({
            frame: frame - i * 4,
            fps,
            config: { damping: 100, stiffness: 100 },
          });
          const width = (bar.value / 100) * 100 * sp;
          return (
            <div key={bar.label}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline",
                  marginBottom: 12,
                }}
              >
                <div
                  style={{
                    color: "#f8fafc",
                    fontSize: 36,
                    fontWeight: 600,
                  }}
                >
                  {bar.label}
                </div>
                <div
                  style={{
                    color: bar.color,
                    fontSize: 40,
                    fontWeight: 800,
                  }}
                >
                  {Math.round(bar.value)}%
                </div>
              </div>
              <div
                style={{
                  height: 36,
                  borderRadius: 18,
                  background: "#1e293b",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    width: `${width}%`,
                    height: "100%",
                    background: `linear-gradient(90deg, ${bar.color} 0%, ${bar.color}cc 100%)`,
                    borderRadius: 18,
                    boxShadow: `0 0 24px ${bar.color}66`,
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
